import Image from "next/legacy/image";
import { blurDataURL, stadium2 } from "../../../utils/constants/images";
import { LIVE_MATCH_URL } from "../../../utils/constants/websiteUrls";
import { FixtureHighlightsButton } from "../../common/buttons/MatchHighlightsButton";
import { FixtureReviewButton } from "../../common/buttons/MatchReviewButton";
import TeamName from "./TeamName";
import TeamLogo from "./TeamLogo";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const LastMatchBanner = ({ fixture }) => {
  return (
    <>
      <div className="relative h-60 md:h-64 lg:h-72 xl:h-80 2xl:h-96 mx-2 sm:mx-4 lg:mx-auto lg:max-w-5xl xl:max-w-6xl 2xl:max-w-[1220px]">
        <div className="absolute h-full w-full mx-auto object-cover mix-blend-multiply">
          <Image
            src={stadium2}
            alt="Baba Yara Stadium"
            layout="fill"
            objectFit="cover"
            priority
            className="object-cover mix-blend-multiply"
          />
          <div className="bg-gradient-to-b from-black to-black absolute inset-0 opacity-90"></div>
        </div>
        <div className="absolute p-2 ml-2 sm:ml-4">
          <p className="text-white text-xs sm:text-sm">{"Last Match "}</p>
        </div>
        <div className="absolute flex flex-col justify-center items-center inset-0 mr-10 ml-10 space-y-10">
          <div className="absolute flex justify-between items-start">
            <div className="flex flex-col justify-center items-center space-y-2">
              <TeamLogo teamLogo={fixture.home_team_logo} />

              <TeamName teamName={fixture.home_team} />
            </div>
            <div className="absolute inset-0 h-6 w-6 sm:h-8 sm:w-8 mx-auto">
              <Image
                src={fixture.competition_logo}
                alt="Competition Logo"
                layout="fill"
                objectFit="contain"
                quality={100}
                placeholder="blur"
                blurDataURL={blurDataURL}
              />
            </div>

            <div className="flex flex-col justify-base items-center px-6 sm:px-16 text-center  pt-10">
              <div className="text-xs inline-flex justify-center items-center">
                <p className="text-white font-semibold text-3xl sm:text-6xl">
                  {fixture.home_team_score}
                </p>

                <p className="text-gray-400 px-5 text-base sm:text-7xl">-</p>

                <p className="text-white font-semibold text-3xl sm:text-6xl">
                  {fixture.away_team_score}
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-center items-center space-y-2">
              <TeamLogo teamLogo={fixture.away_team_logo} />

              <TeamName teamName={fixture.away_team} />
            </div>
          </div>
        </div>
        <div className="absolute bottom-4 left-0 right-0 flex flex-col items-center justify-center text-center mx-auto text-gray-400 text-xs">
          <p className="w-[70vw] truncate text-ellipsis">
            {fixture.competition}
          </p>
          <p className="w-[70vw] truncate text-ellipsis">
            {fixture.week_or_round_number}
          </p>
        </div>
      </div>

      {(fixture.is_live_match_created || fixture.highlight_url) && (
        <div
          className={classNames(
            fixture.highlight_url
              ? "h-40 sm:h-40 md:h-40"
              : "h-20 sm:h-20 md:h-20",
            "bg-red-600 dark:bg-green-800 lg:h-20 mx-2 sm:mx-4 lg:mx-auto lg:max-w-5xl xl:max-w-6xl 2xl:max-w-[1220px] mb-20"
          )}
        >
          <div
            className={classNames(
              fixture.highlight_url ? "p-6" : "p-4",
              "flex flex-col sm:flex-col md:flex-col lg:flex-row xl:flex-row 2xl:flex-row items-center justify-center  sm:p-4 sm:space-y-6 sm:space-x-0 md:space-y-6 md:space-x-0 lg:space-y-0 lg:space-x-6"
            )}
          >
            {fixture.is_live_match_created && (
              <FixtureReviewButton
                matchReportUrl={`${LIVE_MATCH_URL}/${fixture.slug}`}
              />
            )}

            {fixture.highlight_url && (
              <FixtureHighlightsButton highlightUrl={fixture.highlight_url} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default LastMatchBanner;
